import React from 'react';
import { CheckIcon } from 'lucide-react';
import { plans } from '../../data/site';
export function PlansSection() {
  return <section aria-labelledby="plans-title" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28" data-id="element-121" data-mp="17d4o8lx9fesv">
      <div className="max-w-2xl" data-id="element-122" data-mp="sp1jffuye95n">
        <h2 id="plans-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-123" data-mp="slm54f93t45a">
          Ponctuel ou régulier, à vous de choisir
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-124" data-mp="1lcxbu8dhpewm">
          Deux façons de travailler ensemble. Le tarif dépend de votre jardin : il est toujours fixé
          après la visite.
        </p>
      </div>

      <div className="mt-14 grid gap-6 lg:grid-cols-[1fr_1.25fr]" data-id="element-125" data-mp="1cdsdp35ubnkz">
        {plans.map(plan => <article key={plan.name} className={`flex flex-col rounded-xl p-8 md:p-10 ${plan.featured ? 'bg-forest text-cream' : 'border border-line bg-cream'}`} data-id="element-126" data-mp="1gevsdmc5jdkm">
            <h3 className={`font-serif text-3xl ${plan.featured ? 'text-white' : 'text-forest'}`} data-id="element-127" data-mp="tpqg12yno5z9">{plan.name}</h3>
            <p className={`mt-2 text-lg ${plan.featured ? 'text-cream/80' : 'text-ink-muted'}`} data-id="element-128" data-mp="oryk7xuw3zps">{plan.tagline}</p>
            <p className={`mt-6 leading-relaxed ${plan.featured ? 'text-cream/90' : 'text-ink'}`} data-id="element-129" data-mp="12rpv3pq40zzk">{plan.forWho}</p>
            <ul className={`mt-8 space-y-3 border-t pt-8 ${plan.featured ? 'border-cream/20' : 'border-line'}`} data-id="element-130" data-mp="yo1ob99ay8fd">
              {plan.points.map(point => <li key={point} className="flex items-start gap-3" data-id="element-131" data-mp="17qt2vhxh5kb8">
                  <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${plan.featured ? 'text-cream' : 'text-moss'}`} aria-hidden="true" data-id="element-132" data-mp="1mexnwsk027x6" />
                  <span data-id="element-133" data-mp="1hi6yhemb1zz3">{point}</span>
                </li>)}
            </ul>
            <div className="mt-auto pt-10" data-id="element-134" data-mp="1vdj44h201aus">
              <a href="#devis" className={`inline-flex whitespace-nowrap rounded-full px-6 py-3 text-sm font-medium transition-colors duration-150 ${plan.featured ? 'bg-cream text-forest hover:bg-white' : 'border border-forest text-forest hover:bg-forest hover:text-cream'}`} data-id="element-135" data-mp="1qhagef9qk9c0">
                Demander un devis
              </a>
            </div>
          </article>)}
      </div>
    </section>;
}